import { Container, IDestroyOptions, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { CheckBox } from "by/gamefactory/cityversetycoon/scenes/common/components/CheckBox";
import { GameFont } from "../../../../common/GameFont";

export class BuildingFilterSwitcher extends Container {
    private static readonly SWITCH_ON_TEXT = "TURN ON TO DISPLAY ONLY BUILDINGS THAT SUPPORT MON TOKEN";
    private static readonly SWITCH_OFF_TEXT = "TURN OFF TO DISPLAY ALL BUILDINGS";

    private switchButton: CheckBox;
    private switchText: Text;

    public get switcher(): CheckBox {
        return this.switchButton;
    }

    public constructor(
        private readonly offTexture: Texture,
        private readonly onTexture: Texture
    ) {
        super();
        this.build();
    }

    private build(): void {
        this.switchButton = new CheckBox({
            checked: false,
            style: {
                unchecked: new Sprite(this.offTexture),
                checked: new Sprite(this.onTexture)
            }
        });
        this.switchHandle = this.switchHandle.bind(this);
        this.switchButton.onChange.connect(this.switchHandle);
        this.switchText = new Text(BuildingFilterSwitcher.SWITCH_ON_TEXT, new SwitchTextStyle());
        this.switchText.position.set(this.switchButton.width + 17, this.switchButton.height * 0.5 - this.switchText.height * 0.5);
        this.addChild(this.switchButton, this.switchText);
    }

    private switchHandle(checked: boolean): void {
        this.switchText.text = checked ? BuildingFilterSwitcher.SWITCH_OFF_TEXT : BuildingFilterSwitcher.SWITCH_ON_TEXT;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.switchButton.onChange.disconnect(this.switchHandle);
        super.destroy(options);
    }
}

class SwitchTextStyle extends TextStyle {
    public constructor() {
        super({
            align: "center",
            fill: [
                "#ff4d4d",
                "#ff03ba"
            ],
            fillGradientType: 0,
            fillGradientStops: [
                0.3
            ],
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 32
        });
    }
}
